import * as Sentry from "@sentry/react";
import packageJson from '../../package.json';

export function notifySentryError(err, { user, urlpass, params, location }) {
  // Ignorar errores de red del lado del cliente (desconexión, CORS, adblockers, timeouts)
  if (
    err?.message === 'Network Error' || 
    err?.message === 'timeout exceeded' || 
    (err?.message || '').toLowerCase().includes('timeout') ||
    err?.code === 'ECONNABORTED' ||
    (err?.isAxiosError && !err?.response)
  ) {
    console.warn('Sentry ignore: Client network/timeout error', err);
    return; // No lo enviamos a Sentry
  }

  // Ignorar errores de infraestructura del servidor (502, 503, 504)
  if (err?.response?.status === 502 || err?.response?.status === 503 || err?.response?.status === 504) {
    console.warn(`Sentry ignore: Server infrastructure error (${err?.response?.status})`, err);
    return; // No lo enviamos a Sentry
  }

  // Configurar usuario (equivalente a event.addMetadata('user', {...}))
  Sentry.setUser({
    id: user?.user?.user?.id_alumno,
    username: user?.user?.user?.Nombre,
    email: user?.user?.user?.email,
    matricula_academica: user?.user?.user?.No_de_matriculaacademica,
    matricula: user?.user?.user?.No_de_matricula,
    instituto: user?.user?.user?.INSTITUTO
  });

  // Metadata adicional (equivalente a event.addMetadata)
  Sentry.setContext('otherDetails', {
    url: urlpass,
    params
  });

  if (location) {
    Sentry.setContext('location', location);
  }
  Sentry.setContext('appDetails', {
    version: packageJson.version
  });

  // Capturar la excepción
  if (err?.isAxiosError) {
      const simplifiedError = new Error(err.message || 'Error en petición Axios');
      simplifiedError.name = 'AxiosError';
      simplifiedError.stack = err.stack;
      
      Sentry.setContext('axios_details', {
          status: err.response?.status,
          statusText: err.response?.statusText
      });
      Sentry.captureException(simplifiedError);
  } else {
      Sentry.captureException(err);
  }
}